import {
  AccountCircleOutlined,
  Add,
  AddOutlined,
  ArrowBack,
  ArrowBackOutlined,
  ArrowLeft,
  ArrowLeftOutlined,
  ArrowRightAlt,
  AutoAwesome,
  AutoAwesomeOutlined,
  AutoModeOutlined,
  CancelOutlined,
  Clear,
  CloseOutlined,
  Delete,
  DeleteOutline,
  Description,
  DownloadOutlined,
  Edit,
  EditOutlined,
  FiberManualRecord,
  FilterAltOffOutlined,
  FilterAltOutlined,
  FolderOutlined,
  FolderSpecialOutlined,
  Home,
  HomeOutlined,
  KeyboardDoubleArrowLeft,
  MenuOpen,
  MoreHoriz,
  MoreVertOutlined,
  Search,
  UploadOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  Divider,
  Fab,
  FormControl,
  FormHelperText,
  FormLabel,
  Icon,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Select,
  Skeleton,
  Tab,
  Tabs,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
  useTheme,
  alpha,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import { LightTooltip } from "../styled/CustomComponent";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { HttpStatusCode } from "axios";
import {
  Entity_Label,
  FolderType,
  ModulePath,
  Severity,
  VerificationStatus,
  VerificationType,
} from "../../constant/ApplicationVariables";
import useErrorHandler from "../../api/errorHandler/useErrorHandler";
import { handleHomeClick } from "../../components/layout/ApplicationSidebar/index";
import {
  addModule_API,
  deleteModule_API,
  updateModule_API,
} from "../../api/controller/ModuleController";
import { getFolderStructureList_API } from "../../api/controller/RequirementController";
import { useApplicationContext } from "../../context/ApplicationContext";
import { font } from "../../styles/font";
import validator from "validator";
import {
  register_API,
  resetPassword_API,
} from "../../api/controller/authController";
import { updateUserDetail_API } from "../../api/controller/userController";
import { MuiTelInput } from "mui-tel-input";
import MediaComponent from "../media/MediaComponent";
import Cropper from "react-easy-crop";
import TaskCard from "./TaskCard";
import { amber, blue, green, yellow } from "@mui/material/colors";
import CreateTaskComponent from "./CreateTaskComponent";
import EditTaskComponent from "./EditTaskComponent";
import { KeyboardShortcuts } from "../../constant/KeyboardKeys";
import { useHotkeys } from "react-hotkeys-hook";
import { useTranslation } from "react-i18next";
import {
  addProject_API,
  deleteProject_API,
  getProjectCategoryList_API,
  getProjectList_API,
  getProjectSubcategoryList_API,
  updateProject_API,
} from "../../api/controller/ProjectController";
import { debounce } from "../../utils/Functions";
import { VirtuosoGrid } from "react-virtuoso";
import { forwardRef } from "react";
import { TaskCustomIcon, TasksCustomIcon } from "../styled/CustomIcons";
import DeleteConfirmationDialog from "../dialog/DeleteConfirmationDialog";
import {
  getTaskList_API,
  updateDeleteTask_API,
} from "../../api/controller/TaskController";

const Priority = {
  low: "Low",
  medium: "Medium",
  high: "High",
};

const TaskStatus = {
  todo: "To do",
  inProgress: "In Progress",
  needReview: "Need Review",
  done: "Done",
};

const TaskStatusColor = {
  [TaskStatus.todo]: amber,
  [TaskStatus.inProgress]: blue,
  [TaskStatus.needReview]: yellow,
  [TaskStatus.done]: green,
};

function GetTaskStatusColor(status, colorStrength) {
  let colStrength = colorStrength || 50;
  let trimedStatus = status;

  return TaskStatusColor[trimedStatus][colStrength] || blue[colStrength];
}

export default function TaskContainer() {
  const theme = useTheme();

  return (
    <Box className="flex flex-col gap-0 h-full w-full box-border overflow-hidden">
      {/* main container */}
      <Box className="flex-1 flex flex-col gap-4 px-0 py-0 h-full relative overflow-hidden">
        <TaskComponent />
      </Box>
    </Box>
  );
}

function TaskComponent() {
  const {
    activeProject,
    setActiveProject,
    handleSnackbar,
    activeProjectSubcategory,
    setActiveProjectSubcategory,
    activeProjectCategory,
    setActiveProjectCategory,
    headerSearchText,
    setHeaderSearchText,
    handlePageDetails,

    taskList,
    setTaskList,
    currentTaskData,
    setCurrentTaskData,
    openCreateTaskDialog,
    setOpenCreateTaskDialog,
    openEditTaskDialog,
    setOpenEditTaskDialog,
    openDeleteTaskDialog,
    setOpenDeleteTaskDialog,
  } = useApplicationContext();
  const theme = useTheme();
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();

  const { t } = useTranslation("translation", { keyPrefix: "project" });

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(
    theme.breakpoints.up("sm") && theme.breakpoints.down("md"),
  );
  const isLaptop = useMediaQuery(
    theme.breakpoints.up("md") && theme.breakpoints.down("lg"),
  );
  const isDesktop = useMediaQuery(
    theme.breakpoints.up("lg") && theme.breakpoints.down("xl"),
  );
  const isLargeDisplay = useMediaQuery(theme.breakpoints.up("xl"));

  const [isLoading, setIsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");

  const handleOpenItem = (itemData) => {
    handleOpenEdit(itemData);
  };

  const handleOpenEdit = (itemData) => {
    setCurrentTaskData(itemData);
    setOpenEditTaskDialog(true);
  };

  const handleCloseEdit = () => {
    setOpenEditTaskDialog(false);
    setCurrentTaskData(null);
  };

  const handleConfirmEdit = () => {
    handleGetItemsList();
  };

  const handleOpenCreateDialog = () => {
    setOpenCreateTaskDialog(true);
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateTaskDialog(false);
  };

  const handleConfirmCreateDialog = () => {
    handleGetItemsList();
  };

  const handleDeleteItem = (itemData) => {
    setCurrentTaskData(itemData);
    setOpenDeleteTaskDialog(true);
  };

  const handleCloseDeleteItem = () => {
    setOpenDeleteTaskDialog(false);
    setCurrentTaskData(null);
  };

  const handleConfirmDeleteItem = () => {
    handleUpdateDeleteItem();
  };

  const handleKeyDown = (e, project) => {
    if (e.key === "Enter") {
      handleOpenItem(project);
    }
    if (e.key === "Delete") {
      handleDeleteItem(project);
    }
    if (e.key === "F2") {
      handleOpenEdit(project);
    }
  };

  const handleFilterItem = (item, index) => {
    if (statusFilter)
      return item?.status?.toLowerCase() === statusFilter?.toLowerCase();
    else {
      return true;
    }
  };

  const handleSearchFilter = (item, index) => {
    if (headerSearchText) {
      return item.title
        ?.toLowerCase()
        .includes(headerSearchText?.toLowerCase());
    } else {
      return item;
    }
  };

  const handleGetItemsList = async () => {
    try {
      setIsLoading(true);

      let query = `name=${activeProject?.name}`;

      const response = await getTaskList_API(query);
      console.log(response, "response handleGetItemsList");

      if (response) {
        errorHandler(response, setIsLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setTaskList(response.data);
        if (openCreateTaskDialog) {
          handleCloseCreateDialog();
        } else if (openEditTaskDialog) {
          handleCloseEdit();
        } else if (openDeleteTaskDialog) {
          handleCloseDeleteItem();
        }
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  const handleUpdateDeleteItem = async () => {
    try {
      setIsLoading(true);
      let body = {
        id: currentTaskData?.id,
        delete: openDeleteTaskDialog ? true : false,
        projectName: activeProject?.name,
        lastModifiedAt: currentTaskData?.lastModifiedAt,
      };
      const response = await updateDeleteTask_API(body);
      if (response.status === HttpStatusCode.Ok) {
        handleSnackbar(
          response?.message || "Task updated successfully",
          Severity.success,
        );
        handleGetItemsList();
      }
      if (response) {
        errorHandler(response, setIsLoading);
      }
    } catch (error) {
      console.log(error, "projectreponse errorr");
      handleSnackbar("Failed to update task", Severity.error);
    }
  };

  // To get the items list
  useEffect(() => {
    if (taskList?.length === 0 && activeProject) {
      handleGetItemsList();
    }
  }, [taskList?.length, activeProject]);

  return (
    <Box className="flex flex-col gap-6 px-0 py-0 relative h-full w-full overflow-hidden">
      {/* header */}
      <Box className="w-full h-fit flex justify-between sticky top-0 z-10 backdrop-blur-sm px-0 py-0">
        <Header
          projectsList={taskList
            ?.filter(handleFilterItem)
            ?.filter(handleSearchFilter)}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
        />
      </Box>

      {/* items list */}
      <Box className="grow flex flex-col overflow-hidden">
        {isLoading ? (
          <Box className="w-full h-full flex flex-col items-center justify-center gap-2">
            <CircularProgress
              size={24}
              sx={{ color: theme.palette.primary.main }}
            />
            <Typography sx={{ color: theme.palette.text.secondary }}>
              Loading tasks...
            </Typography>
          </Box>
        ) : taskList?.length === 0 ? (
          <Box className="grow flex flex-col gap-2 justify-center items-center">
            {/* <TaskCustomIcon
              sx={{ 
                fontSize: font.size.fs_1,
                color: theme.palette.primary.main,
                opacity: 0.5
              }}
            />
            <Typography
              sx={{ color: theme.palette.text.secondary }}
            >
              {`No ${Entity_Label.task} found`}
            </Typography> */}
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight={400}
              gap={2}
              sx={{ mt: 4 }}
            >
              <TasksCustomIcon
                sx={{
                  fontSize: 80,
                  color: (theme) => theme.palette.text.secondary,
                  opacity: 0.7,
                }}
              />
              <Typography variant="h5" color="text.secondary" fontWeight={500}>
                No tasks found
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ opacity: 0.8 }}
              >
                Create your first task to get started
              </Typography>
              <Button
                startIcon={<Add />}
                onClick={() => setOpenCreateTaskDialog(true)}
                sx={{
                  mt: 2,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  height: 40,
                  px: 3,
                  background:
                    "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
                  color: "hsl(var(--primary-foreground))",
                  boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
                    boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                Create New Task 
              </Button>
            </Box>
          </Box>
        ) : taskList?.filter(handleFilterItem)?.filter(handleSearchFilter)
            ?.length === 0 ? (
          <Box className="grow flex flex-col gap-0 justify-center items-center">
            <TaskCustomIcon
              sx={{
                fontSize: font.size.fs_1,
                color: theme.palette.text.secondary,
                opacity: 0.5,
              }}
            />
            <Typography
              fontSize={font.size.fs_4}
              sx={{ color: theme.palette.text.secondary }}
            >
              {`No ${Entity_Label.task} found`}
            </Typography>
          </Box>
        ) : (
          <>
            <Box className="flex flex-col gap-2 w-full px-0 overflow-y-auto">
              <VirtuosoGrid
                data={taskList
                  ?.filter(handleFilterItem)
                  ?.filter(handleSearchFilter)
                  ?.sort(
                    (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt),
                  )}
                totalCount={
                  taskList?.filter(handleFilterItem)?.filter(handleSearchFilter)
                    .length
                }
                initialItemCount={10}
              //  overscan={10}
                style={{
                  height: "100vh",
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fill, minmax(min(100%, 240px), 1fr))",
                  gap: theme.spacing(2),
                }}
                components={{
                  List: forwardRef(({ style, ...props }, ref) => (
                    <div
                      ref={ref}
                      {...props}
                      style={{
                        ...style,
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(min(100%, 240px), 1fr))",
                        gap: theme.spacing(2),
                        width: "100%",
                      }}
                    />
                  )),
                }}
                itemContent={(index, itemData) => (
                  <Box
                    key={`project-card ${itemData?.name}`}
                    aria-label={`Project Card ${itemData?.name}`}
                    tabIndex={0}
                    onKeyDown={(e) => handleKeyDown(e, itemData)}
                    onClick={() => handleOpenItem(itemData)}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                      overflow: "hidden",
                      borderRadius: theme.shape.borderRadius,
                      backgroundColor: theme.palette.background.paper,
                      border: `1px solid ${theme.palette.divider}`,
                      boxShadow: theme.shadows[0],
                      "&:hover": {
                        boxShadow: theme.shadows[4],
                        borderColor: theme.palette.primary.main,
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                      height: "100%",
                    }}
                  >
                    <TaskCard
                      item={itemData}
                      handleClick={() => {}}
                      handleEditClick={() => handleOpenEdit(itemData)}
                      handleClickDelete={() => handleDeleteItem(itemData)}
                    />
                  </Box>
                )}
              />
            </Box>
          </>
        )}
      </Box>

      {openCreateTaskDialog && (
        <CreateTaskComponent
          open={openCreateTaskDialog}
          onClose={handleCloseCreateDialog}
          handleConfirm={handleConfirmCreateDialog}
        />
      )}
      {openEditTaskDialog && currentTaskData && (
        <EditTaskComponent
          open={openEditTaskDialog}
          onClose={handleCloseEdit}
          handleConfirm={handleConfirmEdit}
        />
      )}
      {openDeleteTaskDialog && currentTaskData && (
        <DeleteConfirmationDialog
          open={openDeleteTaskDialog}
          data={`${currentTaskData?.title}`}
          title={`Delete Task`}
          description={`Are you sure you want to delete task?`}
          handleContinue={handleConfirmDeleteItem}
          handleClose={handleCloseDeleteItem}
        />
      )}
    </Box>
  );
}

function Header({ statusFilter, setStatusFilter }) {
  const {
    handleSnackbar,
    categoryList,
    setCategoryList,
    subCategoryList,
    setSubCategoryList,
    activeProjectCategory,
    setActiveProjectCategory,
    activeProjectSubcategory,
    setActiveProjectSubcategory,
    headerSearchText,
    setHeaderSearchText,
  } = useApplicationContext();
  const theme = useTheme();
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const { t } = useTranslation("translation", { keyPrefix: "project" });

  const [loading, setLoading] = useState(false);
  const [openCategorySelect, setOpenCategorySelect] = useState(false);
  const [openSubCategorySelect, setOpenSubCategorySelect] = useState(false);

  let timer;

  const handleChangeProjectCategory = debounce((event) => {
    setActiveProjectCategory(event.target.value);
  }, 300);

  const handleChangeProjectSubcategory = debounce((event) => {}, 300);

  const handleClearFilter = () => {
    setActiveProjectCategory(null);
    setActiveProjectSubcategory(null);
  };

  const handleChangeSearch = debounce((e) => {
    setHeaderSearchText(e.target.value);
  }, 300);

  const handleKeyDown = (e) => {
    e.stopPropagation();

    if (e.key === "Enter") {
      if (e.target.name === "category") {
        setOpenCategorySelect(true);
      }
      if (e.target.name === "subCategory") {
        setOpenSubCategorySelect(true);
      }
    }
  };

  return (
    <Box
      className="w-full h-full flex flex-col px-4 py-2 gap-4"
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* search / filter container */}
      <Box className="w-full h-fit flex items-center gap-6">
        <Box className="flex items-center">
          <Box
            className="flex items-center cursor-pointer rounded p-1"
            onClick={() => navigate(ModulePath.projects)}
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                opacity: 0.9,
              },
              borderRadius: theme.shape.borderRadius,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              transition: "background-color 0.2s ease",
            }}
          >
            <HomeOutlined
              fontSize="small"
              sx={{
                color: theme.palette.primary.contrastText,
              }}
              className="!text-white dark:!text-black"
            />
          </Box>
        </Box>

        <Box className="w-full h-fit flex items-center gap-4">
          <Box className="flex items-center" sx={{ flexShrink: 0 }}>
            {/* Home button */}
          </Box>

          {/* Search - fixed width */}
          <Box sx={{ width: 240, flexShrink: 0 }}>
            <TextField
              fullWidth
              type="search"
              placeholder="Search tasks..."
              value={headerSearchText}
              onChange={handleChangeSearch}
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: theme.palette.background.default,
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.primary.main,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.primary.main,
                    borderWidth: 2,
                  },
                },
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: theme.palette.text.secondary }} />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>

          {/* Status filter - same fixed width */}
          <Box sx={{ width: 240, flexShrink: 0 }}>
            <FormControl size="small" variant="outlined" fullWidth>
              <Select
                size="small"
                value={statusFilter || ""}
                onChange={(e) => setStatusFilter(e.target.value)}
                displayEmpty
                fullWidth
                sx={{
                  backgroundColor: theme.palette.background.default,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.divider,
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value="">All Status</MenuItem>
                <MenuItem value="OPEN">Open</MenuItem>
                <MenuItem value="CLOSE">Closed</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function StatusContainer({ status, handleClickMore, children }) {
  const theme = useTheme();

  return (
    <Box
      className="flex flex-col gap-0 px-0 py-0 overflow-hidden min-w-64 w-full max-w-[40vw] h-full"
      sx={{
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.background.default, 0.5),
      }}
    >
      {/* header container */}
      <Box className="flex items-center w-full h-fit gap-2 px-0 py-2">
        <Box className="flex-1 flex items-center gap-1">
          <FiberManualRecord
            sx={{
              color: GetTaskStatusColor(status, 500),
              fontSize: "0.75rem",
            }}
          />
          <Typography
            fontSize={font.size.fs_5}
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
            }}
            className="flex-1"
          >
            {status}
          </Typography>
          <Avatar
            sx={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              width: 22,
              height: 22,
              fontSize: font.size.fs_6,
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            5
          </Avatar>
        </Box>

        <IconButton
          onClick={handleClickMore}
          size="small"
          sx={{
            color: theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
            },
          }}
        >
          <MoreVertOutlined fontSize="small" />
        </IconButton>
      </Box>

      {/* list container */}
      <Box
        className="flex-1 flex flex-col gap-4 overflow-y-auto w-full h-full p-2"
        sx={{
          borderRadius: theme.shape.borderRadius,
          backgroundColor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.background.default, 0.3)
              : theme.palette.grey[50],
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
